import GeneralView from '../views/GeneralView.vue';
import ProductView from '../views/ProductView.vue';
import UsageTrackerView from '../views/UsageTrackerView.vue';

// import { store } from './store.js';

export const routes = [{
	path: '',
	name: 'General',
	component: GeneralView,
}, {
	path: '/product/:url',
	name: 'Product',
	component: ProductView,
},
{
	path: '/usage',
	name: 'UsageTracker',
	component: UsageTrackerView,
	// beforeEnter: (to, from, next) => {
	// 	if (store.state.currentUser) next(); // mirar si volem posar alguna validació
	// 	else next(false);
	// },
},
];
